var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcodeArea"},[_c('div',{staticClass:"barcodeInner"},[_c('div',{staticClass:"barcodeHeader"},[_vm._v("利用者番号："+_vm._s(_vm.libraryUserId))]),_c('img',{staticClass:"mt-6 mb-6",attrs:{"src":"https://placehold.jp/332x222.png","id":"barcode","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }